"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _classnames = _interopRequireDefault(require("classnames"));
var _determineIsTab = _interopRequireDefault(require("./utils/determineIsTab"));
var _determineIsDesabledTab = _interopRequireDefault(require("./utils/determineIsDesabledTab"));
var _getDebouncedMethod = _interopRequireDefault(require("../../utils/getDebouncedMethod"));
var _randomId = _interopRequireDefault(require("../../utils/randomId"));
var _excluded = ["className", "theme", "testId", "type", "size", "align", "stretch"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  type: 'primary',
  selectedIndex: 0,
  stretch: true,
  excludePanels: false,
  align: 'top',
  theme: {}
};
var defaultContext = {
  registerBar: function registerBar() {},
  registerTabList: function registerTabList() {}
};

/**
 * Used for displaying content separated by tabs.
 */
var Tabs = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Tabs, _React$Component);
  function Tabs(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Tabs);
    _this = _callSuper(this, Tabs, [props]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "debouncedMoveTabBar", (0, _getDebouncedMethod["default"])(250, _this.moveTabBar.bind((0, _assertThisInitialized2["default"])(_this))));
    _this.state = _objectSpread(_objectSpread({}, props), {}, {
      focusedIndex: _this.props.selectedIndex
    });
    _this.barNode = null;
    _this.tablistNode = null;
    _this.childRefs = [];
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.registerBar = _this.registerBar.bind((0, _assertThisInitialized2["default"])(_this));
    _this.registerTabList = _this.registerTabList.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getNextIndex = _this.getNextIndex.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getPrevIndex = _this.getPrevIndex.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setFocusTab = _this.setFocusTab.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(Tabs, [{
    key: "getChildContext",
    value: function getChildContext() {
      var registerBar = this.registerBar,
        registerTabList = this.registerTabList;
      return {
        registerBar: registerBar,
        registerTabList: registerTabList
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.debouncedMoveTabBar.init);
    }

    // eslint-disable-next-line camelcase
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.state.selectedIndex !== nextProps.selectedIndex) {
        this.setState({
          selectedIndex: nextProps.selectedIndex,
          focusedIndex: nextProps.selectedIndex
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      this.moveTabBar();
      this.setFocusTab(prevState);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.debouncedMoveTabBar.init);
    }
  }, {
    key: "setFocusTab",
    value: function setFocusTab(prevState) {
      var focusedIndex = this.state.focusedIndex;
      var childWithFocus = this.childRefs[focusedIndex];
      if (childWithFocus && focusedIndex !== prevState.focusedIndex) {
        childWithFocus.focus();
      }
    }
  }, {
    key: "setSelected",
    value: function setSelected(index, eventObject) {
      var _this$props = this.props,
        onBeforeChange = _this$props.onBeforeChange,
        onChange = _this$props.onChange;

      // Don't do anything if nothing has changed
      if (index === this.state.selectedIndex) return;

      // Keep reference to last index for event handler
      var last = this.state.selectedIndex;
      if (onBeforeChange) {
        var canSwitchTabs = this.props.onBeforeChange({
          value: index,
          event: eventObject,
          prevValue: last
        });
        if (!canSwitchTabs) return;
      }

      // Update selected index
      this.setState({
        selectedIndex: index,
        focusedIndex: index
      });

      // Call change event handler
      if (onChange) {
        this.props.onChange({
          value: index,
          event: eventObject,
          prevValue: last
        });
      }
    }
  }, {
    key: "getTab",
    value: function getTab(index) {
      return this.tablistNode.childNodes[index];
    }
  }, {
    key: "getNextIndex",
    value: function getNextIndex(currentIndex) {
      var next = currentIndex === 0 ? this.childRefs.length - 1 : currentIndex - 1;
      if (!this.childRefs[next]) {
        return this.getNextIndex(next);
      }
      return next;
    }
  }, {
    key: "getPrevIndex",
    value: function getPrevIndex(currentIndex) {
      var prev = currentIndex === this.childRefs.length - 1 ? 0 : currentIndex + 1;
      if (!this.childRefs[prev]) {
        return this.getPrevIndex(prev);
      }
      return prev;
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      var _this2 = this;
      var index = 0;
      var count = 0;
      var _this$props2 = this.props,
        children = _this$props2.children,
        theme = _this$props2.theme;
      var state = this.state;
      // A random unique id is generated the selected tab and tabpanel
      var selectedId = this.props.selectedId || (0, _randomId["default"])();
      var selectedTabId = "tab-".concat(selectedId);
      var selectedPanelId = "tabpanel-".concat(selectedId);

      // Map children to dynamically setup refs
      var DynamicallySetupRefs = function DynamicallySetupRefs(child) {
        // eslint-disable-line
        return /*#__PURE__*/_react["default"].cloneElement(child, {
          ref: 'tablist',
          children: _react["default"].Children.map(child.props.children, function (tab) {
            if (tab) {
              var ref = "tabs-".concat(index);
              var focused = state.focusedIndex === index;
              var selected = state.selectedIndex === index;
              var disabled = tab.props.disabled;
              var localIndex = index;
              index += 1;
              return /*#__PURE__*/_react["default"].cloneElement(tab, {
                'id': selected ? selectedTabId : null,
                ref: ref,
                'getRef': function getRef(elem) {
                  if (!disabled) {
                    _this2.childRefs[localIndex] = elem;
                  }
                },
                'aria-controls': selected ? selectedPanelId : null,
                focused: focused,
                selected: selected,
                'onMouseOver': function onMouseOver(e) {
                  return tab.props.onMouseOver && tab.props.onMouseOver({
                    event: e,
                    value: localIndex
                  });
                },
                'className': (0, _classnames["default"])(tab.props.className, theme.tab, selected && theme.selected, disabled && theme.disabled)
              });
            }
            return tab;
          })
        });
      };

      // Traversal of components
      var traversalOfComponents = function traversalOfComponents(child, firstStep) {
        // eslint-disable-line
        return /*#__PURE__*/_react["default"].cloneElement(child, {
          children: _react["default"].Children.map(firstStep ? child : child.props.children, function (subChild) {
            // eslint-disable-line
            if (subChild.type && subChild.type.displayName === 'TabList') {
              return DynamicallySetupRefs(subChild);
            }
            if (subChild && subChild.props && subChild.props.children) {
              return traversalOfComponents(subChild, false);
            }
          })
        });
      };

      // Map children to dynamically setup refs
      return _react["default"].Children.map(children, function (child) {
        if (child) {
          var result = null;

          // Clone TabList and Tab components to have refs
          if (count === 0) {
            count += 1;
            // TODO try setting the uuid in the 'constructor' for `Tab`/`TabPanel`
            if (child.type.displayName === 'TabList') {
              result = DynamicallySetupRefs(child);
            } else {
              result = traversalOfComponents(child, true);
            }
            // Reset index for panels
            index = 0;
          } else {
            // Clone TabPanel components to have refs
            var ref = "panels-".concat(index);
            var selected = state.selectedIndex === index;
            index += 1;
            result = /*#__PURE__*/_react["default"].cloneElement(child, {
              'id': selected ? selectedPanelId : null,
              'aria-labelledby': selected ? selectedTabId : null,
              ref: ref,
              selected: selected
            });
          }
          return result;
        }
        return child;
      });
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      // If the keypress occurs inside a form input, it should be handled by the form. Ignore it.
      if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement) {
        return;
      }
      var eventKey = event.key;
      if (eventKey === 'Tab') {
        this.setState({
          focusedIndex: this.state.selectedIndex
        });
      }
      if (eventKey === 'ArrowRight') {
        var newFocusedIndex = this.getPrevIndex(this.state.focusedIndex);
        if (this.state.selectWithArrows) {
          this.setSelected(newFocusedIndex, event);
        } else {
          this.setState({
            focusedIndex: newFocusedIndex
          });
        }
      }
      if (eventKey === 'ArrowLeft') {
        var _newFocusedIndex = this.getNextIndex(this.state.focusedIndex);
        if (this.state.selectWithArrows) {
          this.setSelected(_newFocusedIndex, event);
        } else {
          this.setState({
            focusedIndex: _newFocusedIndex
          });
        }
      }
      if (eventKey === 'Enter') {
        var selectedIndex = this.state.focusedIndex;
        this.setSelected(selectedIndex, event);
      }
    }
  }, {
    key: "registerBar",
    value: function registerBar(node) {
      var theme = this.props.theme;
      this.barNode = node;
      if (this.barNode) {
        this.barNode.className = theme.bar;
      }
    }
  }, {
    key: "registerTabList",
    value: function registerTabList(node) {
      var theme = this.props.theme;
      this.tablistNode = node;
      if (this.tablistNode) {
        this.tablistNode.className = theme.tablist;
      }
      this.moveTabBar();
    }

    /* move tab active bar to active tab */
  }, {
    key: "moveTabBar",
    value: function moveTabBar() {
      if (!this.barNode) return;
      if (this.props.align === 'top') {
        this.moveTabBarTop();
      } else {
        this.moveTabBarLeft();
      }
    }
  }, {
    key: "moveTabBarTop",
    value: function moveTabBarTop() {
      var selectedIndex = this.state.selectedIndex;
      var bar = this.barNode;
      bar.style.transition = '0.15s ease-in-out';
      var tab = _reactDom["default"].findDOMNode(this.getTab(selectedIndex)); // eslint-disable-line

      var tabLeft = tab.offsetLeft - tab.scrollLeft + tab.clientLeft;
      bar.style.display = 'block';
      bar.style.left = "".concat(tabLeft, "px");
      bar.style.width = "".concat(tab.offsetWidth, "px");
      bar.style.top = "".concat(this.tablistNode.offsetHeight + 6, "px");
      return false;
    }
  }, {
    key: "moveTabBarLeft",
    value: function moveTabBarLeft() {
      var selectedIndex = this.state.selectedIndex;
      var bar = this.barNode;
      bar.style.transition = '0.15s ease-in-out';
      var tab = _reactDom["default"].findDOMNode(this.getTab(selectedIndex)); // eslint-disable-line

      var tabTop = tab.offsetTop - tab.scrollTop + tab.clientTop;
      bar.style.display = 'block';
      bar.style.top = "".concat(tabTop, "px");
      bar.style.height = "".concat(tab.offsetHeight, "px");
      bar.style.left = 0;
      return false;
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      var node = e.target;
      do {
        if ((0, _determineIsTab["default"])(node)) {
          if ((0, _determineIsDesabledTab["default"])(node)) {
            break;
          }
          e.stopPropagation();
          var index = [].slice.call(node.parentNode.children).indexOf(node);
          this.setSelected(index, e);
          break;
        }
        node = node.parentNode;
      } while (node !== null);
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        className = _this$props3.className,
        theme = _this$props3.theme,
        testId = _this$props3.testId,
        type = _this$props3.type,
        size = _this$props3.size,
        align = _this$props3.align,
        stretch = _this$props3.stretch,
        props = (0, _objectWithoutProperties2["default"])(_this$props3, _excluded);
      if (this.barNode) {
        this.barNode.className = theme.bar;
      }
      var selectWithArrows = props.selectWithArrows ? 'selectWithArrows' : '';

      // removing these props since they are no valid as div html attributes
      delete props.stretch;
      delete props.selectedIndex;
      delete props.excludePanels;
      delete props.onBeforeChange;
      delete props.onChange;
      delete props.selectWithArrows;
      var verticalClass = align !== 'top' ? 'vertical' : '';
      var noStretchClass = !stretch ? 'no-stretch' : '';
      var cssClassNames = (0, _classnames["default"])(className, theme.tabs, theme[type], theme[size], theme[verticalClass], theme[noStretchClass], theme[selectWithArrows]);

      /* eslint-disable jsx-a11y/no-static-element-interactions */
      return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
        className: cssClassNames,
        "data-test-id": testId,
        "data-anypoint-component": Tabs.displayName,
        onClick: this.handleClick,
        onKeyDown: this.handleKeyDown
      }, props), this.getChildren());
    }
  }]);
  return Tabs;
}(_react["default"].Component);
(0, _defineProperty2["default"])(Tabs, "defaultProps", defaultProps);
(0, _defineProperty2["default"])(Tabs, "childContextTypes", defaultContext);
(0, _defineProperty2["default"])(Tabs, "displayName", 'Tabs');
//# sourceMappingURL=Tabs.js.map